import { useEffect, useMemo, useRef, useState } from 'react'

import { FieldError, FieldErrorsImpl, Merge } from 'react-hook-form'

import { FilterType } from '@App/helpers/requestByFilters'

import { LoaderBlocks } from '@UI/crypto_exchange/desktop/components/common/Loader/components/LoaderBlocks'
import OutsideClickHandler from '@UI/crypto_exchange/desktop/components/common/OutsideClickHandler'
import InputTransferWallet from '@UI/crypto_exchange/desktop/components/controls/InputSelect/InputTransferWallet'

import cls from './InputSelect.module.scss'
import { ISelectValue } from './interfaces'

export default function InputSelect({
  setValue,
  items = [],
  name,
  label = '',
  error,
  isLoading = false,
  className = '',
  defaultValue = null,
  type = 'default',
  filterType,
  isTransferWallet = false,
}: {
  setValue: (name: any, value: any) => void
  items: ISelectValue[]
  label?: string
  name: any
  error?: FieldError | Merge<FieldError, FieldErrorsImpl<any>>
  isLoading?: boolean
  className?: string
  filterType?: FilterType
  type?: 'default' | 'alt'
  defaultValue?: string | number | null
  isTransferWallet?: boolean
}) {
  const [selected, setSelected] = useState<ISelectValue>()
  const [search, setSearch] = useState('')

  const [showList, setShowList] = useState(false)

  const containerRef = useRef<HTMLInputElement>(null)

  const listStyles = {
    width: containerRef.current?.clientWidth,
  }

  useEffect(() => {
    if (defaultValue) {
      setSelected(items.find((item) => item.value === defaultValue))
    }
  }, [defaultValue])

  const itemOptions = useMemo(() => {
    if (items.length) {
      return items.filter((item) => item.label.toLowerCase().includes(search.toLowerCase()))
    }
    return []
  }, [search, items])

  const handleHideList = () => {
    setShowList(false)
    setSearch('')
  }

  if (isLoading)
    return (
      <div className={cls.loaderContainer}>
        <LoaderBlocks />
      </div>
    )

  return (
    <OutsideClickHandler handler={() => handleHideList()}>
      <div className={`${cls.inputSelect} ${cls[type]} ${className}`}>
        <div className={cls.label}>
          <span className={cls.labelText}>{label}</span>
          <InputTransferWallet
            selected={selected}
            name={name}
            containerRef={containerRef}
            setShowList={setShowList}
            showList={showList}
            search={search}
            setSearch={setSearch}
            className={`${cls.selectContainer} ${error && !selected && cls.helpErrorBorder}`}
            isTransferWallet={isTransferWallet}
          />
          {error && !selected && <div className={cls.errorContainer}>{error?.message as string}</div>}
        </div>
        {showList && (
          <div className={`${cls.selectList} `} style={listStyles}>
            {!!itemOptions.length &&
              itemOptions.map((item) => {
                if (item.image) {
                  return (
                    <div
                      key={item.value}
                      className={cls.listItem}
                      onClick={() => {
                        filterType
                          ? setValue(name, {
                              value: item.value.toString(),
                              filterType,
                            })
                          : setValue(name, item.value.toString())
                        setShowList(false)
                        setSearch('')
                        setSelected(item)
                      }}
                    >
                      <div className={cls.leftContainer}>
                        <div className={cls.imageContainer}>
                          <img src={item.image} className={cls.currencyImage} alt="currency" />
                        </div>
                        <div>
                          <div>{item.label}</div>
                          {item?.subLabel && <div className={cls.subLabel}>{item?.subLabel}</div>}
                        </div>
                      </div>
                      {item.rightInfo && <div className={cls.rightContainer}>{item.rightInfo}</div>}
                    </div>
                  )
                }

                return (
                  <div
                    key={item.value}
                    className={cls.listItem}
                    onClick={() => {
                      filterType
                        ? setValue(name, {
                            value: item.value.toString(),
                            filterType,
                          })
                        : setValue(name, item.value.toString())
                      setShowList(false)
                      setSearch('')
                      setSelected(item)
                    }}
                  >
                    <div className={cls.leftContainer}>
                      <div className={item.label === selected?.label ? cls.chosenOption : ''}>{item.label}</div>
                      {item?.subLabel && <div className={cls.subLabel}>{item?.subLabel}</div>}
                    </div>
                    {item.rightInfo && <div className={cls.rightContainer}>{item.rightInfo}</div>}
                  </div>
                )
              })}
          </div>
        )}
      </div>
    </OutsideClickHandler>
  )
}
